import { api } from '@/api/core';
import { CASES_LIST_TAG } from '@/api/constants';

export interface PostMatterCreateRequest {
  caseReference: string;
  departmentId: string;
  teamId: string;
  fileHandlerId: string | null;
  clientName: string;
  defendantName: string;
}

export interface PostMatterCreateResponse {
  matterId: string;
}

const matterCreateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postMatterCreate: builder.mutation<PostMatterCreateResponse, PostMatterCreateRequest>({
      query: (body) => ({
        url: '/matter/create',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: CASES_LIST_TAG }],
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { usePostMatterCreateMutation } = matterCreateApi;
